import "core-js/modules/es.parse-int.js";
// Duplicated from ab-common
import { last } from 'lodash';
var getResourceID = function getResourceID(href) {
  return href ? parseInt(last(href.split('/')), 10) : null;
};
export default getResourceID;